import './index.scss';
import React from 'react';
import PropTypes from 'prop-types';
import {
  GeckoModal,
  GeckoModalService,
  GeckoToastService,
  GeckoAlert,
} from 'ui';
import FilePicker from './FilePicker';
import useImportUpload from './hooks/useImportUpload';
import DragUpload from 'components/DragUpload';

const SAMPLE_FILE_LINK = '/example-bot-question-import.csv';
const EXPORT_LINK = 'http://example.com/TODO';
const KNOWLEDGE_BASE_LINK =
  'http://academy.geckoengage.com/en/articles/3099455-import-answers-into-your-geckobot';

function BotAnswersImportUploadModal(props) {
  const [startUpload, isUploading, progress] = useImportUpload(props.botId);

  const isValidCSVFile = (file) => {
    // If all the File APIs are supported
    if (window.FileReader && window.Blob) {
      const filename = file.name.split('.');
      const extension = filename[filename.length - 1];
      // allows Windows10 users to upload CSVs with the MIME Type of an Excel File, instead of text/csv
      if (
        extension === 'csv' &&
        file.type &&
        file.type === 'application/vnd.ms-excel'
      )
        return true;
      // otherwise return false if not csv or of MIME type 'text/csv'
      if (extension !== 'csv' || (file.type && file.type !== 'text/csv'))
        return false;
    }
    return true;
  };

  const onFilePicked = (pickedFile) => {
    if (!isValidCSVFile(pickedFile)) {
      return new GeckoToastService().error('You must select a valid .csv file');
    }
    return startUpload(pickedFile)
      .then((importId) => {
        new GeckoModalService().close(importId);
      })
      .catch((err) => {
        new GeckoToastService().error(err);
      });
  };

  return (
    <div className="BotAnswersImportModal">
      <GeckoModal name="Import Answers">
        <DragUpload
          autoUpload={false}
          hideProgress={true}
          onDrop={(files) => onFilePicked(files[0])}
        >
          <div className="BotAnswersImportUploadModal-content">
            <GeckoAlert type="info">
              <p>
                Bot answer imports allow you to import new answers as well as
                update your existing answers from a spreadsheet.{' '}
                <a href={SAMPLE_FILE_LINK} target="_blank">
                  Download the sample file
                </a>{' '}
                and follow that structure for your spreadsheet.
              </p>
              {/* <p>You can also <a href={EXPORT_LINK} target="_blank">export all your bot answers</a>, modify them in a spreadsheet app and then re-import again to update your bot training data en masse.</p> */}
              <p>
                Find out more in our{' '}
                <a href={KNOWLEDGE_BASE_LINK} target="_blank">
                  knowledge base
                </a>
                .
              </p>
            </GeckoAlert>
            <h3>Upload your file</h3>
            <div className="BotAnswersImportUploadModal-drag-text">
              Drag and drop a .csv here
            </div>
            <FilePicker disabled={isUploading} onFilePicked={onFilePicked} />
            <div
              className="BotAnswersImportUploadModal-progress-bar"
              style={{ display: progress ? 'block' : 'none' }}
            >
              <div style={{ width: `${progress}%` }}></div>
            </div>
          </div>
        </DragUpload>
      </GeckoModal>
    </div>
  );
}

BotAnswersImportUploadModal.propTypes = {
  botId: PropTypes.number.isRequired,
};

export default BotAnswersImportUploadModal;
